/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_type_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I change the size of the signature?`)
};

const es_sig_type_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo cambiar el tamaño de la firma?`)
};

const de_sig_type_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann ich die Größe der Signatur ändern?`)
};

const nl_sig_type_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan ik de grootte van de handtekening wijzigen?`)
};

const fr_sig_type_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puis-je changer la taille de la signature?`)
};

const it_sig_type_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso cambiare la dimensione della firma?`)
};

const pt_br2_sig_type_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso mudar o tamanho da assinatura?`)
};

const pt_sig_type_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso alterar o tamanho da assinatura?`)
};

const ja_sig_type_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`署名のサイズを変更できますか?`)
};

const zh_sig_type_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我可以更改签名的大小吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_type_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_type_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_type_faq2_q", locale)
	if (locale === "en") return en_sig_type_faq2_q(inputs)
	if (locale === "es") return es_sig_type_faq2_q(inputs)
	if (locale === "de") return de_sig_type_faq2_q(inputs)
	if (locale === "nl") return nl_sig_type_faq2_q(inputs)
	if (locale === "fr") return fr_sig_type_faq2_q(inputs)
	if (locale === "it") return it_sig_type_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_sig_type_faq2_q(inputs)
	if (locale === "pt") return pt_sig_type_faq2_q(inputs)
	if (locale === "ja") return ja_sig_type_faq2_q(inputs)
	return zh_sig_type_faq2_q(inputs)
};